class FaqPage {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._elem = elem
        this._menu = this._elem.querySelector('.faq__menu ul')
        this._content = this._elem.querySelector('.faq__content ul')
    }
    onInit () {
        const menuArray = this._menu.querySelectorAll('li a')
        for (let i = 0; i < menuArray.length; i++) {
            menuArray[i].addEventListener('click', (e) => {
                e.preventDefault()
                this.updateContent(e.currentTarget.getAttribute('data-category'))
            })
        }
    }
    updateContent (category) {
        let contentArray = this._content.querySelectorAll('li')
        for (let i = 0; i < contentArray.length; i++) {
            if (contentArray[i].getAttribute('data-category') === category || category === 'All') {
                contentArray[i].classList.remove('faq--hidden')
            } else {
                contentArray[i].classList.add('faq--hidden')
            }
        }
    }
}
export default FaqPage



// WEBPACK FOOTER //
// ./resources/scripts/components/FaqPage.js